'use strict';
const mmWidgets = require('../widgets/mm-widgets');

/*
 *
 * options:
 *
 *	(1). allow copy/paste from and to the same type of browser
 *	2. allow copy from mindmup -> paste into mindmup or other apps (eg word/excel/text editor)
 *	3. allow copy/paste from and to different browsers, but only for mindmup
 *	4. allow paste from mindmup or other apps (eg excel) into mindmup
 *		-> allow paste directly as a node text?
 *		-> allow paste into a structure? (eg guess tab indented, or guess ul/li from html)
 *	5. allow both copy/paste from other apps into mindmup
 *
 */

mmWidgets.fn.clipboardWidget = function (clipboardModel, clipboardConverter) {
	if (!clipboardModel || !clipboardConverter) {
		throw 'invalid-args';
	}
	return mmWidgets.each(this, function () {
		const container = this,
			textElements = ['INPUT', 'TEXTAREA', 'SELECT'],
			shouldHandle = function (pasteEvent) {
				if (!clipboardModel.isEnabled()) {
					return false;
				}
				if (!pasteEvent.target) {
					return false;
				}
				const tagName = pasteEvent.target.tagName.toUpperCase(),
					contentEditable = pasteEvent.target.closest('[contenteditable]');
				return textElements.indexOf(tagName) === -1 && !contentEditable;
			},
			transferFromMindMup = function (e) {
				if (shouldHandle(e)) {
					const contents = clipboardModel[e.type]();
					[clipboardConverter.getNativeContentType(), 'text/plain', 'text/html'].forEach(function (mimeType) {
						e.clipboardData.setData(mimeType, clipboardConverter.serialize(contents, mimeType));
					});
					e.preventDefault();
				}
			};

		container.on('copy', transferFromMindMup);
		container.on('cut', transferFromMindMup);

		container.on('paste', function (e) {
			if (shouldHandle(e)) {
				const toPaste = clipboardConverter.deserialize(e.clipboardData);
				if (toPaste) {
					clipboardModel.paste(toPaste);
					e.preventDefault();
				}
			};
		});
	});
};
